<template>
  <div ref="layout" v-loading="loading" class="page-container">
    <div class="query-title">货权转移申请</div>

    <div class="content table-query">
      <collapse-query2>
        <template slot="content">
          <div class="query-container">
            <el-form
              ref="form"
              :model="conditions"
              inline
              class="form"
              size="mini"
              label-width="100px"
            >
              <el-row>
                <el-col :span="8">
                  <el-form-item label="计划类型">
                    <el-select v-model="conditions.zzfld00002q" clearable>
                      <el-option
                        v-for="item in selectDataOptions['A0002']"
                        :key="item.value"
                        :label="item.name"
                        :value="item.value"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="产品">
                    <wly-input
                      v-model="conditions.productCode"
                      input-type="product"
                      @enter="handleEnter"
                      @handleSuffixClick="showDialog = true"
                    />
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="年度" prop="annual">
                    <el-date-picker
                      v-model="conditions.annual"
                      clearable
                      value-format="yyyy"
                      format="yyyy"
                      type="year"
                      placeholder="选择年"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
              <el-button size="mini" icon="el-icon-refresh-right" @click="reset">重置</el-button>
              <el-button size="mini" icon="el-icon-search" type="primary" @click="initDetail">查询</el-button>
            </el-form>
          </div>
        </template>
      </collapse-query2>

      <div class="table-container">
        <TableCommon
          title="已开票产品"
          :custome-config="() => vxeShowCustom('xTable')"
          :pagination="pagination"
          @pagination-change="handleTablePaginationChange"
        >
          <template #button>
            <table-button name="add" tip="货权转移" @click="goTransfer('1')" />
          </template>
          <vxe-grid
            ref="xTable"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :columns="gridOptions.columns"
            :data="gridOptions.data"
          >
            <template #zZFLD00002Q="{ row }">
              <span>{{ filterDictionary(row.zZFLD00002Q, 'A0002') }}</span>
            </template>
          </vxe-grid>
        </TableCommon>

        <TableCommon
          title="受让货权转移产品"
          :custome-config="() => vxeShowCustom('xTable2')"
          :pagination="pagination2"
          @pagination-change="handleTablePaginationChange2"
        >
          <template #button>
            <table-button name="add" tip="货权转移" @click="goTransfer('2')" />
          </template>
          <vxe-grid
            ref="xTable2"
            class="table-block"
            border
            :highlight-hover-row="true"
            resizable
            :show-overflow="true"
            height="300"
            size="mini"
            :checkbox-config="{ highlight: true }"
            :radio-config="{ highlight: true }"
            :empty-render="{ name: 'NotData' }"
            :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
            :columns="gridOptions2.columns"
            :data="gridOptions2.data"
          >
            <template #infType="{ row }">
              <span>{{ filterDictionary(row.infType, 'A0022') }}</span>
            </template>
          </vxe-grid>
        </TableCommon>
      </div>
    </div>

    <!-- 通用弹窗情况 -->
    <el-dialog
      v-dialogDrag
      title="产品选择"
      :visible.sync="showDialog"
      width="70%"
      :append-to-body="true"
    >
      <template v-if="showDialog">
        <product-select ref="dialogSelect" />
      </template>

      <div slot="footer">
        <el-button
          type="default"
          icon="el-icon-circle-close"
          size="small"
          @click="showDialog = false"
        >取消</el-button>
        <el-button
          type="primary"
          icon="el-icon-circle-check"
          size="small"
          @click="submitHandle"
        >提交</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { filterDictionary } from '@/utils/index'
import { mapGetters } from 'vuex'
import ProductSelect from '@/components/dialog/ProductSelect'
import { apiGetTransferUnFinishedInv, apiGetTransferGoodsInvInfo } from '@/api/applyForGoods/index'

export default {
  components: { ProductSelect },
  data() {
    return {
      isClient: '0',
      showDialog: false,
      dialogTitle: '客户选择',
      loading: false,
      showPageEditDialog: false,
      mode: 'edit',
      currentData: {},
      id: '',
      conditions: {
        zzfld00002q: '',
        productCode: '',
        annual: ''
      },
      selectDataOptions: {
      },
      pagination: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      pagination2: {
        page: 1,
        pagesize: 50,
        totalCount: 0
      },
      gridOptions: {
        buttons: [],
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 30 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          { field: 'annual', title: '年度', width: 60 },
          //  { field: 'custName', title: '开票客户', width: 120 },
          { field: 'orderCustName', title: '订单客户', width: 120 },
          { field: 'ZZFLD00002Q', title: '计划类型', width: 120, slots: { default: 'zZFLD00002Q' }},
          { field: 'invoId', title: '发票号', width: 120 },
          { field: 'manualInvo', title: '提货票', width: 120 },
          { field: 'makDate', title: '开票日期', width: 120 },
          { field: 'productCode', title: '产品编码', width: 120 },
          { field: 'productDesc', title: '产品名称', width: 120 },
          { field: 'invoiceQty', title: '开票总量(件)', width: 100 },
          { field: 'transferQty', title: '已转移数量', width: 90 },
          { field: 'transferPayQty', title: '已发数量', width: 90 },
          { field: 'availableQty', title: '剩余量', width: 90 }
        ],
        data: []
      },
      gridOptions2: {
        buttons: [],
        columns: [
          { type: 'checkbox', title: '', filed: 'checkbox', width: 30 },
          { type: 'seq', field: 'seq', title: '序号', width: 50 },
          // { field: 'invoInfoid', title: '制票通知单号', width: 120 },
          { field: 'transferClient', title: '来源客户编号', width: 100, visible: false },
          { field: 'orderCustName', title: '来源客户名称', width: 120 },
          { field: 'customer', title: '开票客户编号', width: 100, visible: false },
          { field: 'custName', title: '开票客户名称', width: 120 },
          { field: 'receiveClientCode', title: '接收客户', width: 100, visible: false },
          { field: 'receiveClient', title: '接收客户名称', width: 120 },
          { field: 'infType', title: '计划类型', slots: { default: 'infType' }},
          { field: 'productCode', title: '产品编码' },
          { field: 'productDesc', title: '产品名称' },
          { field: 'transferQty', title: '接收转移数量' },
          { field: 'deliveryQuantity', title: '已发货量' },
          { field: 'invoiceQty', title: '开票总量(件)', width: 120, visible: false },
          { field: 'totalTransfer', title: '已转移数量' },
          { field: 'deliveryQty', title: '已发数量', width: 120, visible: false },
          { field: 'availableQty', title: '接收剩余量' }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sum() {
      const sum = this.gridOptions.data.reduce((p, c) => {
        return +c.freezeQuantity + p
      }, 0)
      return sum
    },
    isEdit() {
      return this.conditions.status === 1
    }
  },
  created() {
    this.initDetail()
    this.getSelectDictDataOrigin('A0019')
    this.getSelectDictDataOrigin('A0032')
    this.getSelectDictDataOrigin('A0002')
    this.getSelectDictDataOrigin('A0022')
  },
  methods: {
    filterDictionary,
    reset() {
      this.conditions = {

      }
    },
    async initDetail() {
      this.loading = true
      const { page, pagesize } = this.pagination
      const params = {
        ...this.conditions,
        page,
        pagesize
      }
      // 把params里面字段为空的去掉
      Object.keys(params).forEach(key => {
        if (params[key] === '') {
          delete params[key]
        }
      })
      try {
        const res = await apiGetTransferUnFinishedInv(params)
        this.loading = false
        if (res?.status === 1) {
          const { Rows, Total, page } = res.data
          this.gridOptions.data = Rows
          this.pagination.totalCount = Total
          this.pagination.page = page
        }
        const res2 = await apiGetTransferGoodsInvInfo({ ...this.pagination2 })
        this.loading = false
        const { Rows, Total, page } = res2.data
        this.gridOptions2.data = Rows
        this.pagination2.totalCount = Total
        this.pagination2.page = page
        this.gridOptions2.data.forEach(item => {
          this.$set(item, 'invoiceQty', item.invoiceQuantity)
          this.$set(item, 'deliveryQty', item.deliveryQuantity)
        })
      } catch (error) {
        //
      }
      this.loading = false
    },
    // 处理分页事件table1
    handleTablePaginationChange(pageParams) {
      this.pagination = { ...this.pagination, ...pageParams }
      this.initDetail()
    },
    // 处理分页事件table2
    handleTablePaginationChange2(pageParams) {
      this.pagination2 = { ...this.pagination2, ...pageParams }
      this.initDetail()
    },
    // 跳转到货权转移申请
    goTransfer(type) {
      let rows = this.$refs['xTable'].getCheckboxRecords()
      if (type === '2') {
        rows = this.$refs['xTable2'].getCheckboxRecords()
      }
      if (rows.length > 0) {
        this.$router.push({ name: '货权转移申请单', params: { rows: rows }})
      } else {
        this.$message.info('请选择要转移的产品！')
      }
      // this.$router.push({ name: 'TransferApply', params: '' })
    },
    goTransferApplyFor(row) {
      this.currentData = row
      this.showPageEditDialog = true
    },
    async submitHandle() {
      const data = await this.$refs.dialogSelect.submitForm()
      if (data) {
        this.conditions.productCode = data.PRODUCT_ID
        this.conditions.productName = data.SHORT_TEXT
      }
      this.showDialog = false
    },
    // 控件回车
    async handleEnter(e, type, data, row) {
      // console.log('handleEnter', type, data)
      if (typeof type === 'object') {
        this.errorList && (this.errorList = [type.message])
        return
      }
      if (!data) return
      this.conditions.productCode = data.PRODUCT_ID
      this.conditions.productName = data.SHORT_TEXT
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/apply-for-manage/business-processing/cargoTransferApply.vue